export function DamageCategory() {
    let DamageList= [
     // {
    //     id: '1',
    //     label: 'Liquid Spilage'
    //   }, 
      {
        id: '2',
        label: 'STD'
      }]
      // {
      //   id: '3',
      //   label: 'MPS Damaged'
      // }
    return DamageList;
  
  }


// WEBPACK FOOTER //
// ./src/services/B2BModule/DamageCategoryList.js